import { JSONSchema7 } from 'json-schema';
import { customSchemas, types as commonTypes } from '@sitebuilder/common';
import ListDocuments from './ListDocuments';

const schema: JSONSchema7 = {
    title: 'List documents',
    type: 'object',
    description: 'List documents support the listing of documents using icons, images, and links',
    required: ['link', 'linkName', 'dataKey'],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        dataKey: {
            type: 'string',
            title: 'Data key',
            default: '',
        },
        link: {
            type: 'string',
            title: 'Link',
            description: 'URL for the link',
        },
        linkName: {
            type: 'string',
            title: 'Link Name',
            description: 'Link Name',
        },
        linkIcon: {
            type: 'string',
            title: 'Icon for link',
            default: 'fas fa-link',
        },
        openInNewTab: {
            type: 'boolean',
            default: true,
            title: 'Open link in new tab',
        },
        isImgLink: {
            type: 'boolean',
            default: false,
            title: 'Fetch images from url',
        },
    },
    dependencies: {
        isImgLink: {
            oneOf: [
                {
                    properties: {
                        isImgLink: { enum: [true] },
                        imageLink: {
                            type: 'string',
                            title: 'Base url for the images',
                        },
                        altText: {
                            type: 'string',
                            title: 'Image alt Text',
                            default: 'image',
                            description: 'Eg {{image.name}}',
                        },
                        imgFileName: {
                            type: 'string',
                            title: 'File Name',
                            description: 'File name of the image in the repo',
                        },
                    },
                    required: ['imageLink', 'imgFileName', 'altText'],
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'dataKey',
            'link',
            'linkName',
            'linkIcon',
            'openInNewTab',
            'isImgLink',
            'imageLink',
            'altText',
            'imgFileName',
        ],
    },
];

const ListDocumentsWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        linkName: {
            'ui:widget': 'ResourcePicker',
        },
        imageLink: {
            'ui:widget': 'MediaPicker',
            'ui:options': {
                isImagePicker: true,
            },
        },
    },
    templateView: ListDocuments,
    group: 'component',
    id: 'ListDocuments',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default ListDocumentsWidget;
